import {Injectable} from '@angular/core';
import {ApiWebService} from '../../shared/@types';
import {RecordClassifica, RecordClassificaAnnuale, Torneo, Utente} from '../@types';
import {map} from 'rxjs';
import * as moment from 'moment';
import {
  normalizeTorneo,
  normalizeTorneoConClassifica,
} from '../../shared/custom-operators/custom.operators';
import {UtilsService} from '../../shared/services';

@Injectable({
  providedIn: 'root'
})
export class TorneiService extends ApiWebService {

  constructor() {
    super('tornei');
  }

  getTornei$(params: any = {}) {
    return this.get$<Torneo[]>(params, 'tornei').pipe(
      map(res => res)
    );
  }

  getTorneo$(id: number) {
    return this.getById$<Torneo>(id, this.defaultEndpoint).pipe(
      normalizeTorneo()
    );
  }

  getClassificaAnnuale$(y: string = moment().format('YYYY')) {
    return this.get$<RecordClassificaAnnuale[]>({y}, 'tornei/m/classifica-annuale').pipe(
      map(res => res)
    );
  }

  getClassificaTorneo$(idTorneo: number) {
    return this.get$<RecordClassifica[]>({id: idTorneo}, 'tornei/m/classifica-torneo').pipe(
      map(res => res)
    );
  }

  getAnniTornei$() {
    return this.get$<string[]>({}, 'tornei/m/anni-tornei').pipe(
      map(res => res)
    );
  }

  salvaTorneo$(torneo: Torneo, mode: 'insert' | 'update') {
    if (mode === 'update') {
      return this.put$<{ torneo: Torneo; classifica: RecordClassifica[] }>(torneo.id, torneo, 'tornei').pipe(
        normalizeTorneoConClassifica()
      );
    } else {
      return this.post$<{ torneo: Torneo; classifica: RecordClassifica[] }>(torneo, 'tornei').pipe(
        normalizeTorneoConClassifica()
      );
    }
  }

}
